import styled from 'styled-components'

export const StyledFacebookMessageConfirmOrderWrapper = styled.div`
  width: calc(100% + 48px);
  margin: 0 -24px;
`
